import React, { useState } from 'react';
import '../../styles/PartnerWithUs.css';

function JoinNowForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
  });
  const [loading, setLoading] = useState(false);

  const isFormValid =
    formData.name.trim() !== '' &&
    /^\S+@\S+\.\S+$/.test(formData.email) &&
    /^\d{8}$/.test(formData.phone);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid) {
      alert('Please enter a valid name, email, and 8-digit phone number.');
      return;
    }

    setLoading(true);
    const scriptUrl = 'https://script.google.com/macros/s/AKfycbydAMk1C12dP4qxiS8xOjBSOoscHLr0V6exMeUnRRdqndcjuvnN8ZMduN9BC_TBF3XX_g/exec';

    try {
      await fetch(scriptUrl, {
        method: 'POST',
        body: JSON.stringify({ ...formData, formType: 'Partner' }),
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'no-cors',
      });

      alert('Your request has been submitted. We will contact you shortly!');
      setFormData({ name: '', email: '', phone: '' });
    } catch (err) {
      console.error('Form submission error:', err);
      alert('Oops! Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="joinNowSection">
      <form className="joinForm" onSubmit={handleSubmit}>
        <div className="formGroup">
          <label htmlFor="name">Full Name</label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Your full name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="formGroup">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="you@example.com"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="formGroup">
          <label htmlFor="phone">Phone Number</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            placeholder="8-digit mobile number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" className="joinButton" disabled={!isFormValid}>Submit</button>
      </form>
      {/* Loading Screen */}
      {loading && (
        <div className='loadingOverlay'>
          <div className='loadingSpinner'></div>
          <p>Submitting your request...</p>
        </div>
      )}
    </section>
  );
}

export default JoinNowForm;
